import React from "react";

const BuyAPropertyPage = () => {
  const sectionData = [
    {
      title: "✅ Comprehensive Customer Support",
      description: "",
      items: [
        {
          text: "Search properties on Housing.in",
          image: "/searchProperties.png",
        },
        {
          text: "Shortlist your preferred projects",
          image: "/shortlist.png",
        },
        {
          text: "Get project briefings from experts",
          image: "/expert.png",
        },
        {
          text: "Arrange site visits with our assistants",
          image: "/sitevisits.png",
        },
        {
          text: "Price negotiations and financial planning",
          image: "/pricenegotiation.png",
        },
        {
          text: "Home loans, documentation, and stamp duty assistance",
          image: "/homeLoans.png",
        },
        {
          text: "Finalize the deal with confidence",
          image: "/deals.png",
        },
      ],
    },
    {
      title: "✅ No Brokerage for Buyers",
      description: "We save you money by providing:",
      items: [
        {
          text: "Up to 2% savings on property transactions",
          image: "/deals.png",
        },
        {
          text: "Free-of-cost service from inquiry to possession",
          image: "/expert.png",
        },
      ],
    },
    {
      title: "✅ Unbiased Property Advice",
      description: "We focus on helping you find the perfect property by:",
      items: [
        {
          text: "Prioritizing your requirements, not sales",
          image: "/shortlist.png",
        },
        {
          text: "Providing a wide range of property options",
          image: "/expert.png",
        },
        {
          text: "Maintaining transparency in pricing and features",
          image: "/pricenegotiation.png",
        },
        {
          text: "Allowing you full control of your decisions",
          image: "/searchProperties.png",
        },
      ],
    },
    {
      title: "✅ Detailed Comparative Study",
      description: "Our experts guide you with comprehensive market analysis, covering:",
      items: [
        {
          text: "Locality insights for better neighborhood selection",
          image: "/sitevisits.png",
        },
        {
          text: "Project comparisons to find your perfect fit",
          image: "/shortlist.png",
        },
        {
          text: "Pricing, features, and appreciation rates",
          image: "/deals.png",
        },
        {
          text: "Current market trends for informed decisions",
          image: "/market.png",
        },
      ],
    },
    {
      title: "✅ RERA Registered Projects",
      description: "RERA guidelines ensure transparency and protect your interests:",
      items: [
        {
          text: "Standardized carpet area measurements",
          image: "/measurements.png",
        },
        {
          text: "Minimized risks of fraud and legal safeguards",
          image: "/legal.png",
        },
        {
          text: "Accountability for construction quality",
          image: "/construction.png",
        },
        {
          text: "Compensation for project delays",
          image: "/pricenegotiation.png",
        },
        {
          text: "Advance payments capped at 10%",
          image: "/deals.png",
        },
      ],
    },
  ];

  const achievements = [
    {
      value: "₹10,000 Cr+",
      description: "Worth of Homes Sold",
    },
    {
      value: "55,000+",
      description: "Happy Customers",
    },
    {
      value: "450+",
      description: "Real Estate Experts",
    },
  ];

  return (
    <div className="p-6 bg-gray-50">
      {/* Header Section */}
      <header className="text-center py-6">
        <h1 className="text-3xl font-bold text-gray-800">
          Why Choose <span className="text-blue-600">Housing.in</span>?
        </h1>
        <p className="text-gray-600 mt-2">Your Trusted Partner in Real Estate</p>
      </header>

      {/* Sections */}
      {sectionData.map((section, index) => (
        <section key={index} className="my-8">
          <div className="bg-white shadow-lg rounded-lg p-6 border-l-4 border-blue-500 hover:shadow-xl transition duration-300">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">
              {section.title}
            </h2>
            {section.description && (
              <p className="text-gray-600 mb-4">{section.description}</p>
            )}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {section.items.map((item, idx) => (
                <div
                  key={idx}
                  className="flex items-center bg-gray-50 shadow-md rounded-lg p-4"
                >
                  <img
                    src={item.image}
                    alt={item.text}
                    className="w-16 h-16 rounded-full border-2 border-blue-500 mr-4"
                  />
                  <p className="text-gray-700">{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      ))}

      {/* Achievements Section */}
      <section className="my-12 text-center">
        <h2 className="text-2xl font-bold text-gray-800 mb-6">
          Our Achievements
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {achievements.map((achievement, idx) => (
            <div key={idx} className="bg-white shadow-lg rounded-lg p-6">
              <h3 className="text-xl font-bold text-blue-600">
                {achievement.value}
              </h3>
              <p className="text-gray-600">{achievement.description}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default BuyAPropertyPage;
